import {
  Alert,
  Avatar,
  Backdrop,
  Box,
  Card,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import { Breadcrumb } from "components/Breadcrumb";
import { FC } from "react";

type MainLayoutContainerProps = {
  title: string;
  buttonActions?: React.ReactNode | null;
  children: React.ReactNode;
  description?: string;
  loading?: boolean;
  error?: { message: string } | null;
  breadcrumb?: string | null;
  maxWidth?: number | string;
  avatarSrc?: string | null;
  size?: "small" | "medium";
};

export const MainLayoutContainer: FC<MainLayoutContainerProps> = ({
  title,
  children,
  description = "",
  buttonActions = null,
  loading = false,
  error = null,
  breadcrumb = null,
  maxWidth = "100%",
  avatarSrc = null,
  size = "medium",
}) => {
  return (
    <>
      {breadcrumb && (
        <Box mb={2}>
          <Breadcrumb page={breadcrumb} />
        </Box>
      )}
      <Card>
        <Box p={4}>
          <Stack direction="row" justifyContent="space-between" mb={2}>
            <Stack direction="row" spacing={2}>
              {avatarSrc && <Avatar src={avatarSrc} />}
              <Typography
                variant={size === "small" ? "h5" : "h4"}
                sx={{
                  fontSize: {
                    xs: "1.5rem",
                    md: size === "small" ? "1.75rem" : "2.125rem",
                  },
                }}
              >
                {title}
              </Typography>
            </Stack>
            {buttonActions && <Stack direction="row">{buttonActions}</Stack>}
          </Stack>
          {description !== "" && (
            <Box sx={{ maxWidth: 960 }}>
              <Typography variant="body2">{description}</Typography>
            </Box>
          )}
          {error && <Alert severity="error">{error.message}</Alert>}
          {loading && (
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={loading}
            >
              <Stack direction="column" alignItems="center">
                <CircularProgress color="inherit" />
                <Typography variant="subtitle2" noWrap>
                  Loading...
                </Typography>
              </Stack>
            </Backdrop>
          )}
          {!error && !loading && <Box sx={{ maxWidth }}>{children}</Box>}
        </Box>
      </Card>
    </>
  );
};
